import * as Yup from "yup";

export const productSchema = Yup.object().shape({
  name: Yup.string().required("Название обязательно"),
  price: Yup.number().required("Цена обязательна"),
  category: Yup.string().required("Категория обязательна"),
  unit: Yup.string().required("Единица измерения обязательна"),
  dealer: Yup.string().required("Поставщик обязателен"),
});
